import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/");
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        await exchangeSession(sessionId);
        toast.success("Welcome — you're signed in.");
        navigate("/academy", { replace: true });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [exchangeSession, navigate]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen flex items-center justify-center bg-cream"
    >
      <div className="text-center">
        <div className="font-editorial text-3xl text-[hsl(var(--onyx))]">
          Signing you in…
        </div>
        <div className="mt-3 text-sm text-[hsl(var(--onyx)/0.5)] uppercase tracking-widest">
          One moment
        </div>
      </div>
    </div>
  );
}
